const RANGE_FILTERS = ['prices'];

export const isRangeFilter = (slug: string): boolean =>
  RANGE_FILTERS.includes(slug);

export const RANGE_FILTER_DELIMITER = '-';
